import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import DashboardLayout from "components/layouts/DashboardLayout";
import { useAuth } from "context/AuthContext";
import Loader from "components/Loader";

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { fetchUserData, user, userLoading } = useAuth();
  const [loading, setLoading] = useState(true);
  const theStoredToken = localStorage.getItem("accessToken");

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      fetchUserData(token).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [fetchUserData]);

  if (loading || userLoading) {
    return (
      <DashboardLayout>
        <div></div>
      </DashboardLayout>
    );
  }

  if (!theStoredToken || !user) {
    return <Navigate to="/login" />;
  }

  return <DashboardLayout>{children}</DashboardLayout>;
};

export default PrivateRoute;
